import {createApp} from "vue";
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from "./i18n";

import '@uppy/core/css/style.min.css'
import '@uppy/dashboard/css/style.min.css'

//Vue.config.productionTip = false
createApp(App)
    .use(store)
    .use(router)
    .use(i18n)
    .mount('#app');


/*new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')*/
